<template>
  <div class='content'>
    <van-nav-bar title="票详情列表" left-text="" right-text="" left-arrow @click-left="onClickLeft"
      @click-right="onClickRight" />

    <van-cell-group class='' style="padding-bottom: 80px;">

      <van-row class="">
        <van-col span="24" style="width: 90%;margin-left: 5%; margin-bottom: 10px;">
          <van-col class="" span="24"
            style="border-color: azure; text-align: left;height:33xp;line-height: 33px;border-bottom: 1px solid gainsboro;">
            订单号：{{orderID_}} <span style="display: none;">{{orderOperator}} {{scenicAreaID}}</span>
          </van-col>
          <van-col class="" span="24">
            <van-checkbox-group v-model="result" ref="checkboxGroup">
              <div class="van-checkbox-cell-group" v-for="(item,index) in list" :key="index"
                style="margin-bottom: 20px;margin-top: 10px;">
                <!--   <van-checkbox :name="item" @click="checkbox()" ref="checkbox" :disabled="item.code=='已验票' || item.code=='已退票' || item.code=='已禁用' || item.code=='已出库'|| item.code=='已入库'|| item.code=='已挂失'|| item.code=='已作废'" > -->
                <van-checkbox :name="item" @click="checkbox()" ref="checkbox" :disabled="item.isRefund=='false'">
                  <van-col span="24">
                    <van-col span="18" style="font-size: 13px;">{{item.ticket}}</van-col>


                    <van-col span="6" style=" text-align: right;">￥{{item.price}}</van-col>
                    <van-col v-if="hide">{{item.subTicketID}} {{item.uniqID}}</van-col>
                  </van-col>
                  <van-col span="24">
                    <van-col span="18" style="color: #999999;margin-top: 6px; font-size: 13px;"> {{item.ticketTypeName}}
                    </van-col>
                    <van-col span="6" style="margin-top: 6px; font-size: 13px;text-align: right;"> {{item.code}}
                    </van-col>
                  </van-col>

                  <van-col span="24"  v-if="hide_refundlist">
                    <van-col span="16" style="color: #999999;margin-top: 6px; font-size: 13px;"  v-if="hide_refund2">{{item.isRefundCheck}}</van-col>
                    <van-col span="8" style="margin-top: 5px; font-size: 13px;text-align: right;"
                           wx:if="item.isRefundCheck==='需审核' || item.isRefundCheck==='审核失败'  ||  item.isRefundCheck==='审核驳回'">
                          <van-button type="primary" round size="mini"
                          style="background-color:#FFFFFF; color: #369AFF; border: 1px solid #369AFF; width: 80px;" @click="refund_(index)">提交审核
                         </van-button>
                      </van-col>
                  </van-col>

                  <van-col span="24" v-if="hide_refund2">
                    <van-col span="6" style="color: #999999;margin-top: 6px; font-size: 13px;">审核说明</van-col>
                    <van-col span="18" style="margin-top: 6px; font-size: 13px;text-align: right;"> {{item.remark}}
                    </van-col>
                  </van-col>
                  <van-col span="24">
                    <van-col span="12" style="color: #999999;margin-top: 6px; font-size: 13px;">游玩时间:</van-col>
                    <van-col span="12" style="color: #999999;margin-top: 6px; font-size: 13px;text-align: right;">
                      {{item.time}}</van-col>
                  </van-col>
                  <van-col span="24">
                    <van-col span="12" style="color: #999999;margin-top: 6px; font-size: 13px;">结束时间:</van-col>
                    <van-col span="12" style="margin-top: 6px; font-size: 13px;text-align: right;"> {{item.time1}}
                    </van-col>
                  </van-col>
                  <van-col span="24" @click="ticketcs(index)">
                    <van-col span="16" style="margin-top: 6px;color: #369AFF; font-size: 13px;">查看门票对应过闸次数</van-col>
                    <van-col span="8" style="padding-top:2px; text-align: right;">
                      <van-button type="primary" round size="mini"
                        style=" background-color:#FFFFFF; color: #FF4A53; border: 1px solid #FF4A53; width: 80px;">查看
                      </van-button>
                    </van-col>
                  </van-col>
                </van-checkbox>
              </div>
            </van-checkbox-group>

          </van-col>

          <van-col class="" span="24" style="text-align: right;padding-top: 30px;" v-if="hide_refund1">
            <van-col span="12" style="margin-top:14px;font-size: 13px;" >
              退票金额: {{total}}元
            </van-col>
            <span v-if="hide"> {{totalID}}</span>
            <van-col span="12" style="margin-top:8px;" >
              <van-button :disabled="isDisable" round size="small"
                style="width: 100px; color: #FFFFFF; background-color:#FF4A53 ;border:1px solid #FF4A53; "
                @click="refund()"> 退票</van-button>
            </van-col>


          </van-col>

        </van-col>


      </van-row>


    </van-cell-group>
    <van-tabbar v-model="active" active-color="#FF4A53">
      <van-tabbar-item icon="home-o" @click="home()">购票首页</van-tabbar-item>
      <van-tabbar-item icon="setting-o" @click="user()">个人中心</van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        scenicAreaID: "",
        hide_refund1: true,
        hide_refundlist: false,
        hide_refund2: false,
        isDisable_: false,
        hide_refund3: false,
        disabled: "",
        active: 1,
        orderID_: '',
        isDisable: false,
        numlist: '',
        timeDate: '',
        orderOperator: '',
        currentDate: new Date(),
        phone: '',
        text: '',
        message: '',
        isLoadingShow: true,
        hide: false,
        finished: false,
        show: false,
        className: '',
        checked: null,
        list: [],
        arrList: [],
        total: '0',
        result: [],
        showCalendar: false,

      }
    },
    mounted() {
      this.ticketlist();

    },

    computed: {},
    methods: {
      ticketcs(index) {
        let subTicketID = this.list[index].subTicketID;
        this.$router.push({
          path: "/wx_ticketTicket",
          query: {
            subTicketID: subTicketID
          }
        });
      },
      refund_(index) {

         let subTicketID = this.list[index].subTicketID;
          let ticketID = this.list[index].ticket;
          let uniqID = this.list[index].uniqID;
       //  uniqID
        this.isDisable = true;
        setTimeout(() => {
          this.isDisable = false
        }, 1000)
        //let operate = 5; //操作类型 1-续卡、2-编辑、3-挂失/解挂、4-补卡、5-退卡/退票


        //let storage=window.sessionStorage;
        let scenicAreaID = this.scenicAreaID;
        let accountID = this.orderOperator;
        let operate = 0
        var paramsList = [];
        paramsList.push({
          ticketIndex:uniqID.toString(),
          ticketID: ticketID,
          subTicketID: subTicketID,
          operator: accountID,
          scenicAreaID: scenicAreaID.toString(),
        })
        console.log(paramsList)

        //let  = arrList.toString();
        /* if (arr.length == 0) {
          this.$notify({
            type: 'warning',
            message: '请选择需要退的票'
          });
          return;
        } */

        const loading = this.$loading({
          lock: true,
          text: '提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)'
        });
        // 添加数据
        this.$axios({
            url: "/api/refundTicketCheck/checkOperate",
            method: "post",
            data: {
            operate:operate,
            paramsList:paramsList,
            },
            headers: {
              "Content-Type": "application/json; charset=utf-8"
            }
          })
          .then(res => {
            console.log(res.data);
            if (res.data==true) {
              this.$notify({
                type: 'success',
                message: '提交成功等待审核'
              });
              loading.close() //关闭 Loading 加载
              this.ticketlist(); //重新获取数据
              this.total = '0';
            } else {
              this.$notify({
                type: 'error',
                message: '提交失败'
              });
              loading.close() //关闭 Loading 加载
              this.ticketlist(); //重新获取数据
              this.total = '0';
            }
          })
          .catch(err => {
            console.log(err);
            this.$notify({
              type: 'error',
              message: '提交失败'
            });
            loading.close() //关闭 Loading 加载
            this.ticketlist(); //重新获取数据
            this.total = '0';

          });


      },
      refund() {
        this.isDisable = true;
        setTimeout(() => {
          this.isDisable = false
        }, 1000)
        let operate = 5; //操作类型 1-续卡、2-编辑、3-挂失/解挂、4-补卡、5-退卡/退票

        let arrList = [];
        let arr = this.result;
        for (const i in arr) {
          arrList.push(arr[i].ticket);
        }
        let ticketList = arrList;
        console.log(ticketList)
        let refundAmount = Number(this.total)
        let orderID = this.orderID_;
        console.log(orderID)
        let orderAmount = this.totalID;
        let storage=window.sessionStorage;
        let orderOperator =this.orderOperator;
       let scenicAreaID = storage.getItem("scenicAreaID");
        //let  = arrList.toString();
        if (arr.length == 0) {
          this.$notify({
            type: 'warning',
            message: '请选择需要退的票'
          });
          return;

        }
        const loading = this.$loading({
          lock: true,
          text: '退票中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)'
        });
        // 添加数据
        this.$axios({
            url: "/api/sell/ticketBasicOperate",
            method: "post",
            data: {
              scenicAreaID:scenicAreaID,
              operate: operate,
              orderID: orderID,
              refundAmount: refundAmount,
              orderAmount: orderAmount,
              accountID: orderOperator,
              payWay: 9,
              ticketList: ticketList
            },
            headers: {
              "Content-Type": "application/json; charset=utf-8"
            }
          })
          .then(res => {
            console.log(res.data);
            if (res.data.msgCode) {
              this.$notify({
                type: 'success',
                message: '退票成功'
              });
              loading.close() //关闭 Loading 加载
              this.ticketlist(); //重新获取数据
              this.total = '0';
            } else {
              this.$notify({
                type: 'error',
                message: '退票失败'
              });
              loading.close() //关闭 Loading 加载
              this.ticketlist(); //重新获取数据
              this.total = '0';
            }
          })
          .catch(err => {
            console.log(err);
            this.$notify({
              type: 'error',
              message: '退票失败'
            });
            loading.close() //关闭 Loading 加载
            this.ticketlist(); //重新获取数据
            this.total = '0';

          });

      },
      ticketlist() {
           let this_=this;
        this.result = [];
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)'
        });
        let storage=window.sessionStorage;
        let openid = storage.getItem("openid")
        if(openid == null || openid == "null" || openid == "undefined" || openid == undefined || openid== "" ){
             alert("openID获取失败，请退出公众号在重新进入");
        
             return
        
         }
         
        let totalID = this.$route.query.total;
        this.totalID = totalID;
        let orderID = this.$route.query.order;
        this.orderID_ = orderID;
        this.$axios({
            url: "/api/order/wxTicketList",
            method: "get",
            params: {
              openid:openid,
              orderID: orderID,
            }
          })

          /*  this.$axios({
          		url: "/api/order/query",
          		method: "get",
          		params: {
          			orderID: orderID,
          		}
          	}) */
          .then(res => {

            setTimeout(() => {
              loading.close() //关闭 Loading 加载
            }, 800)
            var data = res.data;
            console.log(data)
            this.list = [];

            this.orderOperator = res.data[0].orderOperator;
            this.scenicAreaID = res.data[0].scenicAreaID;
            for (const i in data) {
              if (data[i].ticketStatus == 0) {
                var ticketStatus = "已入库";
              }
              if (data[i].ticketStatus == 1) {
                var ticketStatus = "已出库";

              }
              if (data[i].ticketStatus == 2) {
                var ticketStatus = "未验票"

              }
              if (data[i].ticketStatus == 3) {
                var ticketStatus = "已验票";

              }
              if (data[i].ticketStatus == 4) {
                var ticketStatus = "已退票";

              }
              if (data[i].ticketStatus == 5) {
                var ticketStatus = "已作废";

              }
              if (data[i].ticketStatus == 6) {
                var ticketStatus = "已禁用";
              }

              if (data[i].ticketStatus == 7) {
                var ticketStatus = "已挂失";

              }
              if (data[i].ticketStatus == 8) {
                var ticketStatus = "已过期";

              }

              if (data[i].isRefund == true) {
                if (data[i].refundCheckStatus ==-1 ) {
                    var isRefund = "true";
                 }
                if (data[i].refundCheckStatus == 0 ) {
                    var isRefund = "false";
                 }
                if (data[i].refundCheckStatus == 1 ) {
                       var isRefund = "false";
                 }
                 if (data[i].refundCheckStatus == 2 ) {
                       var isRefund = "true";
                 }
                 if (data[i].refundCheckStatus == 3 ) {
                       var isRefund = "true";
                 }
                // var isRefund= "true";
              } else {
                var isRefund = "false";
              }

              if (data[i].isRefundCheck == 1  ) {
                    this.hide_refundlist=true;
                if (data[i].refundCheckStatus == -1 ) {
                   this_.hide_refund1 = false;
                   this_.hide_refund2 = true;
                   this_.hide_refund3 = true;
                     var refundCheckStatus = "需审核"
                 }
                 if (data[i].refundCheckStatus == 0 ) {
                   this_.hide_refund1 = false;
                   this_.hide_refund2 = true;
                   this_.hide_refund3 = false;
                    var refundCheckStatus = "审核中"
                 }
                 if (data[i].refundCheckStatus ==1) {
                   this_.hide_refund1 = false;
                   this_.hide_refund2 = true;
                   this_.hide_refund3 = false;
                    var refundCheckStatus = "已审核"

                 }
                 if (data[i].refundCheckStatus ==2) {
                   this_.hide_refund1 = false;
                   this_.hide_refund2 = true;
                   this_.hide_refund3 = true;
                    var refundCheckStatus = "审核驳回"
                 }
                 if (data[i].refundCheckStatus ==3) {
                   this_.hide_refund1 = false;
                   this_.hide_refund2 = true;
                   this_.hide_refund3 = true;
                   var refundCheckStatus = "审核失败"
                 }


              } else {
                   this.hide_refundlist=false;
                this.hide_refund1 = true;
                this.hide_refund2 = false;
                this.hide_refund3 = false;
                
              }

              /* if (data[i].refundCheckStatus == -1) {
                var refundCheckStatus = "需审核"
              }
              if (data[i].refundCheckStatus == 0) {
                var refundCheckStatus = "审核中"
              }
              if (data[i].refundCheckStatus == 1) {
                var refundCheckStatus = "已审核"
              }
              if (data[i].refundCheckStatus == 2) {
                var refundCheckStatus = "审核驳回"
              }
              if (data[i].refundCheckStatus == 3) {
                var refundCheckStatus = "审核失败"
              } */
              //  refundCheckStatus
              //remark

              //  refundCheckStatus   退票审核状态(-1 无,0-审核中,1-已审核,2-审核驳回,3-审核失败)

              this.list.push({
                ticket: data[i].ticketID,
                code: ticketStatus,
                isRefund: isRefund,
                ticketTypeName: data[i].ticketTypeName,
                price: data[i].transPrice,
                time: data[i].ticketStart,
                time1: data[i].ticketEnd,
                subTicketID: data[i].subTicketID,
                isRefundCheck: refundCheckStatus,
                remark: data[i].ticketRemark,
                uniqID: data[i].uniqID,
              });



            }
          })
          .catch(err => {
            setTimeout(() => {
              loading.close() //关闭 Loading 加载
            }, 800)
            console.log(err);
          });


      },


      checkbox() {
        let totala = 0;
        for (var i = 0; i < this.result.length; i++) {
          var item = this.result[i];
          totala += item.price * 1;
        }
        if (this.result.length == 0) {
          totala = 0;
        }
        this.total = totala;


      },
      home() {
        this.$router.push({
          path: "/wx_ticketIndex"
        });
      },
      user() {
        this.$router.push({
          path: "/wx_ticketUser"
        });
      },
      onLoad() {
        this.loading = false;
        this.finished = true;

      },
      onClickLeft() {
        this.$router.go(-1); //返回上一层
        //this.$router.push({ path: "/wx_ticketUser",query: { total: total , numlist: numlist }  });
      },
      onClickRight() {

      },
      // 选项格式化函数
      onSubmit() {

      },
      time() {
        this.timeDate = this.dateFormat();
        this.total = this.$route.query.total;
        this.numlist = this.$route.query.numlist;

      },
      onConfirm(date) {
        this.timeDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        this.showCalendar = false;
      },
      dateFormat() { //获取当前时间
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1 < 10 ? +(date.getMonth() + 1) : date.getMonth() + 1;
        var day = date.getDate() < 10 ? +date.getDate() : date.getDate();
        //var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
        //var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
        //var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
        return year + "-" + month + "-" + day
      },
      showPopup() {
        this.show = true
        this.isLoadingShow = true
        setTimeout(() => {
          this.isLoadingShow = false
        }, 500)
      },

    }
  }
</script>

<style scoped>
  .box_visit .list i {
    color: #00B2AD;
    width: 20px;
    height: 20px;
    font-size: 15px;
    margin-left: 10px;
  }

  .content {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
  }

  .box_visit .check {
    text-align: right !important;
  }

  .box_visit .check i {
    margin-left: 0px !important;
    margin-right: 8px !important;
    margin-top: 10px;
  }

  .check_code {
    display: inline-block;
    width: 80px;
    height: 33px;
    position: relative;
    top: -2.5px;
  }

  .icon_color1 i {
    color: #1989fa;
  }

  .icon_color2 i {
    color: #19c160;
  }

  .icon_color3 i {
    color: #07c160;
  }

  .icon_color4 i {
    color: #4fc08d;
  }

  .icon_color5 i {
    color: #2989fa;
  }
</style>



// WEBPACK FOOTER //
// src/system/index/wechatlist/wx_ticketOrderTicket.vue